import { routePaths } from "./routeConstants";

const securePath = routePaths.root;
export const login = `${securePath}/${routePaths.login}`;
export const health = `${securePath}/${routePaths.healthCheck}`;
export const dashboard = `${securePath}/${routePaths.dashboard}`;
export const resourcesPath = `${securePath}/${routePaths.externalResources}`;
export const suggestionPath = `${securePath}/${routePaths.suggestions}`;
